import React from 'react';
import { Link } from 'react-router-dom';
import './StaffAugmentation.css';

const roles = [
  { title: 'Incident Response Specialists', icon: '/images/staff-augmentation-icons/threat-detection.png',      desc: 'Rapid responders who contain, investigate, and eradicate security incidents before damage spreads.' },
  { title: 'Penetration Testers',           icon: '/images/staff-augmentation-icons/penetration-testing.png',   desc: 'Ethical hackers who uncover vulnerabilities in your systems before real attackers do.' },
  { title: 'Security Analysts',             icon: '/images/staff-augmentation-icons/encrypted.png',             desc: 'SOC professionals who monitor, detect, and analyze threats 24/7 across your environment.' },
  { title: 'Security Architects',           icon: '/images/staff-augmentation-icons/key.png',                   desc: 'Strategic designers who build robust, scalable security frameworks aligned to your goals.' },
  { title: 'Solution Architects',           icon: '/images/staff-augmentation-icons/atom.png',                  desc: 'Technical leads who design end-to-end IT and cloud solutions with security at the core.' },
  { title: 'Network Administrators',        icon: '/images/staff-augmentation-icons/network-admin.png',         desc: 'Infrastructure experts who configure, maintain, and secure your network environment.' },
  { title: 'System Administrators',         icon: '/images/staff-augmentation-icons/system-administrator.png',  desc: 'Systems specialists who manage server environments, patching, and hardening at scale.' },
  { title: 'Business Analysts',             icon: '/images/staff-augmentation-icons/presentation.png',          desc: 'Bridge the gap between business requirements and security solutions with clarity and precision.' },
  { title: 'Project Managers',              icon: '/images/staff-augmentation-icons/project-team.png',          desc: 'Experienced PMs who deliver cybersecurity and IT projects on time, on scope, on budget.' },
];

const steps = [
  { n: '01', title: 'Understand Your Needs', desc: 'We dive deep into your organizational culture, technical requirements, and security objectives to define the ideal candidate profile.' },
  { n: '02', title: 'Source & Vet Talent', desc: 'Our extensive network of pre-screened professionals is matched against your specific criteria - technical skills, certifications, and cultural fit.' },
  { n: '03', title: 'Seamless Integration', desc: 'We facilitate smooth onboarding and provide ongoing support to ensure your augmented team members hit the ground running.' },
  { n: '04', title: 'Continuous Support', desc: 'Our relationship doesn\'t end at placement. We provide ongoing quality assurance and responsive support throughout the engagement.' },
];

export default function StaffAugmentation() {
  return (
    <div className="sa-page">
      {/* Hero */}
      <section className="page-hero">
        <div className="container page-hero-content">
          <span className="section-label section-label--blue">Talent Solutions</span>
          <h1>Elite <span style={{ color: '#d5772d' }}>Security Talent</span></h1>
          <p>Integrate vetted IT and cybersecurity professionals seamlessly into your team. We deliver unparalleled expertise to enhance your capabilities, bridge resource gaps, and drive excellence.</p>
        </div>
      </section>

      {/* Value Props */}
      <section className="sa-values">
        <div className="container">
          <div className="sa-values-grid">
            {[
              { icon: '/images/staff-augmentation-icons/staffing.png',         title: 'Expert Staffing Solutions', desc: 'Seasoned professionals with deep industry knowledge across diverse cybersecurity and IT disciplines.' },
              { icon: '/images/staff-augmentation-icons/target.png',          title: 'Client-Centric Approach',   desc: 'We prioritize understanding your specific needs, culture, and objectives to deliver perfect-fit talent.' },
              { icon: '/images/staff-augmentation-icons/quality-control.png', title: 'Quality Assurance',         desc: 'Rigorous vetting from initial assessment through placement with ongoing support throughout every engagement.' },
            ].map((v, i) => (
              <div className="sa-value-card" key={i}>
                <div className="sa-value-icon"><img src={v.icon} alt={v.title} /></div>
                <h3>{v.title}</h3>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Roles */}
      <section className="sa-roles">
        <div className="container">
          <div className="section-header centered">
            <span className="section-label">Available Expertise</span>
            <h2 className="section-title">Security Roles We <span>Place</span></h2>
            <p className="section-desc" style={{ margin: '0 auto' }}>
              Whether you need a single specialist or an entire security team, we have the talent to meet your requirements.
            </p>
          </div>
          <div className="roles-grid">
            {roles.map((role, i) => (
              <div className="role-card" key={i}>
                <div className="role-icon"><img src={role.icon} alt={role.title} /></div>
                <div className="role-info">
                  <h3>{role.title}</h3>
                  <p>{role.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="sa-process">
        <div className="container">
          <div className="section-header centered">
            <span className="section-label">Our Process</span>
            <h2 className="section-title">How We <span>Deliver</span></h2>
          </div>
          <div className="process-grid">
            {steps.map((step, i) => (
              <div className="process-card" key={i}>
                <div className="process-number">{step.n}</div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="sa-cta">
        <div className="container">
          <div className="cta-inner">
            <div className="cta-glow" />
            <div className="cta-content">
              <h2>Ready to Strengthen Your Security Team?</h2>
              <p>Contact us today to discuss how our Staff Augmentation services can align with your organizational goals and drive excellence in IT and Cyber Security.</p>
              <div className="cta-actions">
                <Link to="/jobs" className="btn-outline-white">Browse Open Roles</Link>
                <Link to="/contact" className="btn-primary">
                  Discuss Your Needs
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
